export function removeUrlParam(paramName) {
	if (typeof window !== 'undefined') {
		const newUrl = new URL(window.location.href);
		newUrl.searchParams.delete(paramName);
		window.history.replaceState({}, '', newUrl.toString());
	}
}

export const setLocation = (path, timeout = 300) => {
	if (typeof window !== 'undefined') {
		// Wait 300ms for any tracking events to flush
		setTimeout(() => {
			window.location.href = path;
		}, timeout);
	}
};
